import { Conversation, ConversationMessage, MessageFormField } from "../../types";
import BaseController from "./BaseController";

class ConversationsController extends BaseController {
  static getConversations(): Promise<any> {
    return this.post('messenger/conversations');
  }

  static create(message: ConversationMessage): Promise<Conversation> {
    return this.post('messenger/conversations/create', { message: message });
  }

  static reply(conversationId: string, message: ConversationMessage): Promise<Conversation> {
    return this.post(`messenger/conversations/${conversationId}/reply`, { message: message });
  }

  static read(conversationId: string): Promise<Conversation> {
    return this.post(`messenger/conversations/${conversationId}/read`, { id: conversationId });
  }

  static getView(id?: string): Promise<{ conversation: Conversation }> {
    let payload = {}
    if (id) payload = { ...payload, id: id }
    return this.post('messenger/conversations/view', payload);
  }

  static form(conversationid: string, fields: MessageFormField[]): Promise<Conversation> {
    return this.post(`messenger/conversations/${conversationid}/form`, { form_fields: fields });

  }
}

export default ConversationsController